module.exports = __webpack_public_path__ + "static/media/Bg-LP3.c10ae19c.png";